export enum ErrorCodeInterface {
  UnknownError = 'unknownError',
}
